import { render, staticRenderFns } from "./ComboboxBase.vue?vue&type=template&id=5cb181fa&scoped=true"
import script from "./ComboboxBase.vue?vue&type=script&lang=js"
export * from "./ComboboxBase.vue?vue&type=script&lang=js"
import style0 from "./ComboboxBase.vue?vue&type=style&index=0&id=5cb181fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb181fa",
  null
  
)

export default component.exports